'use client'
import React from 'react'
import { Roboto } from 'next/font/google'
const roboto = Roboto({ weight: ["300", "400", "500", "700"], subsets: ["latin"] })
import ErrorAnimation from '@/components/ErrorAnimation/ErrorAnimation'

const page = () => {
  return (
    <div className="flex flex-col h-screen overflow-x-hidden justify-center items-center bg-[#201D1D]">
        <ErrorAnimation />
        <h1 className={`text-white text-xl font-bold ${roboto.className} text-center`}>Application <span className='text-[#F73A3A]'>Error</span> : A Client Side Exception has occured</h1>
    </div>
  )
}

export default page